import React from 'react';

interface OptionButtonProps {
  label: string;
  value: any;
  description?: string;
  selected: boolean;
  onClick: (value: any) => void;
}

const OptionButton: React.FC<OptionButtonProps> = ({ label, value, description, selected, onClick }) => {
  return (
    <button
      type="button"
      onClick={() => onClick(value)}
      style={{
        width: '100%',
        background: selected ? 'rgba(250,253,251,0.12)' : 'rgba(250,253,251,0.08)',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)',
        border: `2px solid ${selected ? 'var(--color-primary)' : 'rgba(250,253,251,0.08)'}`,
        borderRadius: 16,
        padding: '20px 16px',
        color: 'var(--color-text-light)',
        fontFamily: "'Figtree', sans-serif",
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '140%',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        textAlign: 'left',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
      onMouseEnter={(e) => {
        if (!selected) e.currentTarget.style.background = 'rgba(250,253,251,0.12)';
      }}
      onMouseLeave={(e) => {
        if (!selected) e.currentTarget.style.background = 'rgba(250,253,251,0.08)';
      }}
    >
      <span>{label}</span>
      {description && (
        <span style={{ fontSize: 14, color: 'rgba(250,253,251,0.5)' }}>{description}</span>
      )}
    </button>
  );
};

export default OptionButton;
